import React from 'react'
import loading from './loading.gif'

const Spinner = () => {
  return (
      <div style={{height: '50px', width: '50px', margin: 'auto', display: 'block', textAlign: 'center',marginTop:'20px',marginBottom:'20px'}}>
        <img src={loading} alt="loading..." />
      </div>
  )
}

export default Spinner